const isTouchDevice = () =>
  "ontouchstart" in window ||
  navigator.maxTouchPoints > 0 ||
  navigator.msMaxTouchPoints > 0
    ? true
    : false;

const Tooltip = ({ position, iconColor, iconSize, information }) => {
  return (
    <span style={{zoom:"118%"}}>
      <se-tooltip
        action={isTouchDevice() ? "click" : "hover"}
        position={position}
      >
        <se-icon
          option="raised"
          slot="tooltip"
          color={iconColor}
          size={iconSize}
        >
          information_circle
        </se-icon>
        <se-tooltip-content style={{ textAlign: "left" }}>
          {information}
        </se-tooltip-content>
      </se-tooltip>
    </span>
  );
};

export default Tooltip;
